import { Stack, StepIcon } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";

const GuidelineStepByStep = ({ children }) => {
  const steps = Array.isArray(children) ? children : [children];

  const colors = useColors();

  // Filter out null or undefined children
  const filteredSteps = steps.filter((step) => step);

  return (
    <Stack direction="column" spacing={4}>
      {filteredSteps.map((step, inx) => (
        <Stack key={inx} direction="row" spacing={2}>
          <StepIcon
            icon={inx + 1}
            sx={{ color: colors.primary_dark, width: 25, height: 25 }}
          />
          {step}
        </Stack>
      ))}
    </Stack>
  );
};

export default GuidelineStepByStep;
